<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Code:</label>
	<input class="form-control" type="text" placeholder="Code or Abbreviation" [(ngModel)]="MealSubsidyTypeCD" />

	<label>Description:</label>
	<input class="form-control" type="text" placeholder="Name or Description" [(ngModel)]="MealSubsidyTypeDesc" />

	<label>Subsidy Percent:</label>
	<div class="InstructionGrid">
		<input class="form-control" type="number" min="0" max="100" step="0.1" [(ngModel)]="MealSubsidyPct" />
		<label>(% Discount on meals. Ex. Free = 100%, Full Price = 0%)</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="processing == true" class="btn btn-primary" (click)="onAdd()">
		{{ EditMode == true ? "Update" : "Add" }}
	</button>
	<button [disabled]="processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
